import { useParams, useSearchParams } from 'react-router-dom';
import { VISIBILITY_KEYS } from '../../../../../../utils/constants/visibilityKeys';
import { useFeatureVisibility } from '../../../../../../utils/useVisibilityConfig';

interface UseHeaderButtonContainerLogicProps {
    selectedCompany: any;
}

const useHeaderButtonContainerLogic = ({ selectedCompany }: UseHeaderButtonContainerLogicProps) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const params = useParams();
    const { magicSignVisibility } = useFeatureVisibility({
        magicSignVisibility: VISIBILITY_KEYS.MAGIC_SIGN.ENABLED,
    });

    const openCompanyMagicSign = () => {
        // Never open the company-scoped Magic Sign view without a real org id — an empty
        // orgId would render the company drawer with no company context.
        const orgId = selectedCompany?.assesseeOrgId || (params?.id as string);
        if (!orgId) return;
        searchParams.set('magicSign', 'true');
        searchParams.set('isCompany', 'true');
        // Clear any stale needInfo left by a prior Data Requests visit — the drawer's default-tab
        // priority is needInfo > magicSign (useMagicUploadLogic), so a lingering needInfo=true would
        // hijack the default tab away from Magic Sign even though we set magicSign below.
        searchParams.delete('needInfo');
        // Surface the Data Requests tab alongside Magic Upload + Magic Sign, so this entry offers the
        // same tab set as the company Data Requests / Magic Upload entries (mirrors DashboardHeader's
        // openMagicUpload). NOTE: set showNeedInfo (renders the tab) but NOT needInfo — needInfo would
        // hijack the default tab; the drawer must still open on Magic Sign. The tab's borrowerReq fetch
        // is set by changeDrawerContent('needInfo') on tab click, and it only mounts once visited.
        searchParams.set('showNeedInfo', 'true');
        searchParams.set('orgId', orgId);
        searchParams.set('companyName', selectedCompany?.orgName ?? '');
        setSearchParams(searchParams);
    };

    return { magicSignVisibility, openCompanyMagicSign };
};

export default useHeaderButtonContainerLogic;
